define('shared/remote/payment/adyen/initSession',[
    'shared/remote/ajax',
    './constructSessionPayload',
    'shared/page/apiVersion'
], function (
    ajax,
    constructSessionPayload,
    getAPIVersion
) {
        return function (offers) {
            return getAPIVersion()
                .then(function(apiVersion) {
                    if (apiVersion === 'new-house') {
                        return constructSessionPayload(offers).then(function (sessionPayload) {
                            return ajax({
                                url: '/1/api/commerce-gateway/order/adyen-capture',
                                method: 'post',
                                data: sessionPayload,
                            });
                        });
                    }

                    return constructSessionPayload(offers).then(function (sessionPayload) {
                        return ajax({
                            url: '/services/commerce-v4/offermanager/CreateOrderByStandaloneCapture',
                            method: 'post',
                            data: sessionPayload,
                        });
                    });
                });
        };
    });

